import React from 'react';
import AdminLayout from '../../components/admin/layout/AdminLayout';
import OverviewStats from '../../components/admin/dashboard/OverviewStats';
import QuickActions from '../../components/admin/dashboard/QuickActions';
import RecentActivities from '../../components/admin/dashboard/RecentActivities';
import SystemHealth from '../../components/admin/dashboard/SystemHealth';
import TopCompaniesWidget from '../../components/admin/dashboard/TopCompaniesWidget';
import PopularSearchesWidget from '../../components/admin/dashboard/PopularSearchesWidget';
import WebPerformanceWidget from '../../components/admin/dashboard/WebPerformanceWidget';

const AdminDashboard: React.FC = () => {
  return (
    <AdminLayout title="แผงควบคุมหลัก">
      <div className="space-y-8">
        {/* Welcome Section */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-lg p-6 text-white">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold mb-2">
                ยินดีต้อนรับสู่ Admin PanelX
              </h1>
              <p className="text-blue-100">
                จัดการระบบไดเร็กทอรี่บริษัทรักษาความปลอดภัยไทย
              </p>
            </div>
            <div className="text-right">
              <p className="text-sm text-blue-100">วันที่</p>
              <p className="text-lg font-semibold">
                {new Date().toLocaleDateString('th-TH', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                  weekday: 'long'
                })}
              </p>
            </div>
          </div>
        </div>

        {/* Overview Statistics */}
        <OverviewStats />

        {/* Quick Actions */}
        <QuickActions />

        {/* Two Column Layout for Activities and System Health */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Recent Activities */}
          <div className="lg:col-span-1">
            <RecentActivities />
          </div>

          {/* System Health */}
          <div className="lg:col-span-1">
            <SystemHealth />
          </div>
        </div>

        {/* Additional Info Cards - Using Real API Widgets */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <WebPerformanceWidget />
          <TopCompaniesWidget />
          <PopularSearchesWidget />
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;